import { render } from "./CreateDialog.vue?vue&type=template&id=7bf6e4c8&scoped=true"
import script from "./CreateDialog.vue?vue&type=script&lang=js"
export * from "./CreateDialog.vue?vue&type=script&lang=js"

import "./CreateDialog.vue?vue&type=style&index=0&id=7bf6e4c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf6e4c8"]])

export default __exports__